module.exports = __webpack_public_path__ + "img/system47.51492bd9.png";